<template>
  <v-avatar :class="['avatar', dynamicAvatarClass]" :size="size" :color="color">
    <img
        :src="avatarSrc"
        referrerpolicy="no-referrer"
        alt="avatar"
        loading="lazy"
    />
  </v-avatar>
</template>

<script>
import speaker from '@/assets/images/profile/speaker-default.png'
import exhibitor from '@/assets/images/profile/exhibitor-default.png'

export default {
	name: 'Avatar',
	props: {
		avatar: {
			type: String,
			default: '',
		},
		size: {
			type: Number,
			default: 50,
		},
		color: {
			type: String,
			default: '#e0e0e0',
		},
		borderRadius: {
			type: String,
			default: 'circle',
		},
    defaultAvatar: {
      type: String,
      default: '',
    }
	},
	computed: {
    avatarSrc() {
      if (!this.avatar) {
        return this.defaultAvatar === 'speaker'? speaker : exhibitor
      }
      return this.avatar
    },
		dynamicAvatarClass() {
			return {
				'rounded-lg': this.$props.borderRadius === 'square',
			}
		},
	},
}
</script>

<style lang="scss">
.avatar {
	img {
		object-fit: cover;
	}

	&__default-icon {
		border-radius: 25px;
	}
}
</style>
